import { Component, OnInit, inject, ChangeDetectorRef } from '@angular/core'
import packageJson from '../../../../../package.json'
import { VersionService } from '../../../services/version.service'

@Component({
    selector: 'lg-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  private versionService = inject(VersionService);
  private cdr = inject(ChangeDetectorRef);

  frontVersion = packageJson.version
  backVersion: string

  ngOnInit(): void {
    this.versionService.getBackVersion().subscribe((version) => {
      this.backVersion = version
      this.cdr.detectChanges()
    })
  }
}
